import React, { useEffect, useState } from "react";
import { Link, useLocation,useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const { id } = useParams();
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [chartOfAccount, setChartOfAccount] = useState({});
  const [alert, setAlert] = useState(null);
  const date = new Date();

  // Get first day of current month
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)
    .toLocaleDateString('en-CA'); // This gives YYYY-MM-DD format

  // Get last day of current month  
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    .toISOString()
    .split('T')[0];
  const [inputs, setInputs] = useState({
    start_date: firstDayOfMonth,
    end_date: lastDayOfMonth
  });
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    try {
      let url = `/report/sub-category-ledger?id=${id}`;

      // Add date range filters if provided
      if (inputs.start_date) {
        url += `&start_date=${inputs.start_date}`;
      }
      if (inputs.end_date) {
        url += `&end_date=${inputs.end_date}`;
      }

      const res = await Http.get(url);
      setReceiveData(res.data.list || []);
      setChartOfAccount(res.data.chart_of_account || {});
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  // Refetch data when inputs change
  useEffect(() => {
    fetchData();
  }, [inputs.month, inputs.year]);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const formSubmit = () => {
    let url = `/report/sub-category-ledger?id=${id}`;
    if (inputs.start_date) {
      url += `&start_date=${inputs.start_date}`;
    }
    if (inputs.end_date) {
      url += `&end_date=${inputs.end_date}`;
    }

    Http.get(url).then((res) => {
      setReceiveData(res.data.list || []);
      setChartOfAccount(res.data.chart_of_account || {});
    });
  };

  const cols = [
    { field: "date", header: "Date" },
    { field: "serial_number", header: "VR_CD No" },
    { field: "chart_of_account", header: "Acc Code & Name" },
    { field: "subsidiary", header: "Sub Category" },
    { field: "bill_number", header: "Bill No" },
    { field: "bill_date", header: "Bill Date" },
    { field: "mature_day", header: "Mature Date" },
    { field: "dr_cr", header: "D/C" },
    { field: "debit", header: "DR" },
    { field: "credit", header: "CR" },
    { field: "balance", header: "Balance" },
    { field: "opening_balance", header: "Opening Balance" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Chart Of Account Ledger Report</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          .header { text-align: center; margin-bottom: 30px; }
          .date-range { text-align: center; margin-bottom: 20px; font-weight: bold; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #f2f2f2; font-weight: bold; }
          .text-right { text-align: right; }
          .text-center { text-align: center; }
          @media print {
            body { margin: 0; }
            .no-print { display: none; }
          }
        </style>
      </head>
      <body>
        <div class="header">
           <h1 style="margin: 0; font-size: 24px; font-weight: bold;">Ideal Textile Limited</h1>
           <h3 style="margin: 10px 0; font-size: 18px;">${chartOfAccount.code || ''} - ${chartOfAccount.name || 'Chart of Account'}</h3>
           <h4 style="margin: 5px 0; font-size: 16px;">Chart of Account Statement From ${inputs.start_date} TO ${inputs.end_date}</h4>
         </div>
        <table>
          <thead>
            <tr>
              ${cols.map(col => `<th>${col.header}</th>`).join('')}
            </tr>
          </thead>
          <tbody>
            ${receiveData.map(row => `
              <tr>
                <td class="text-center">${row.date || ''}</td>
                <td>${row.chart_of_account || ''}</td>
                <td class="text-center">${row.serial_number || ''}</td>
                <td>${row.type || ''}</td>
                <td class="text-center">${row.dr_cr || ''}</td>
                <td>${row.subsidiary || ''}</td>
                <td class="text-right">${row.debit ? parseFloat(row.debit).toLocaleString() : ''}</td>
                <td class="text-right">${row.credit ? parseFloat(row.credit).toLocaleString() : ''}</td>
                <td class="text-right">${row.balance ? parseFloat(row.balance).toLocaleString() : ''}</td>
                <td class="text-right">${row.opening_balance ? parseFloat(row.opening_balance).toLocaleString() : ''}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() {
              window.close();
            }
          }
        </script>
      </body>
      </html>
    `;
    
    printWindow.document.write(printContent);
    printWindow.document.close();
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            {/* <h5 className="am-title">Chart Of Account History - ({receiveData.chart_of_account.code}) - {receiveData.chart_of_account.name}</h5> */}
            <h5 className="am-title">Sub Category Ledger</h5>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-sm-40">
              <div className="row g-3">
                <div className="col-lg">
                  <div className="form-group">
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="start_date"
                      value={inputs.start_date}
                      onChange={handleInputChange}
                      max={inputs.end_date}
                    />
                  </div>
                </div>

                <div className="col-lg">
                  <div className="form-group">
                    <label>End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="end_date"
                      value={inputs.end_date}
                      onChange={handleInputChange}
                      min={inputs.start_date}
                    />
                  </div>
                </div>

                <div className="col-lg-2 d-flex align-items-center">
                  <button
                    className="btn btn-primary w-100 mt-2"
                    onClick={formSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <i className="fa fa-spinner fa-spin me-2" /> Loading...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-refresh me-2" /> Submit
                      </>
                    )}
                  </button>
                </div>
                
                <div className="col-lg-2 d-flex align-items-center">
                  <button
                    className="btn btn-success w-100 mt-2"
                    onClick={handlePrint}
                    disabled={loading || !receiveData.length}
                  >
                    <i className="fa fa-print me-2" /> Print
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                // actionTemplate={actionTemplate}
                // deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
